import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";
import { getEditInputsByStep } from "../../config.jsx";

import "./style.scss";

const Step1 = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps }) => {
        const detailData = mainStore.getMainStore("detailData");
        const input = getEditInputsByStep({ mainStore, detailData }).step1 || [];
        return <DefaultDetail apiUrl={"/promo/offers"} inputs={input} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default Step1;
